export const getFileNameFromUrl = (url: string): string => {
  try {
    const clean = url.split("?")[0].split("$$$")[0];
    const parts = clean.split("/");
    return decodeURIComponent(parts[parts.length - 1]) || "document";
  } catch {
    return "document";
  }
};

export const downloadOriginalFile = async (
  url: string,
  filename: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    // NOTE: no `credentials: "include"` here on purpose — most S3/CloudFront
    // setups serve CORS with AllowedOrigins: "*", which is incompatible with
    // credentialed fetches. If your bucket genuinely requires cookies/auth,
    // the CORS config needs an explicit origin (not "*") plus
    // Access-Control-Allow-Credentials: true, and this should become
    // credentials: "include" to match.
    //
    // `cache: "reload"` is required for images. The viewer loads them with
    // <img>, which caches a no-CORS S3 response (no Access-Control-Allow-Origin).
    // Chrome then reuses that cached response for this fetch and reports a CORS
    // failure even though a fresh GET with Origin succeeds. PDFs skip this
    // because they are shown in an iframe, not pre-fetched as images.
    const response = await fetch(url, { mode: "cors", cache: "reload" });

    if (!response.ok) {
      throw new Error(`Fetch failed with status ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error("Downloaded file is empty (0 bytes)");
    }

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  } catch (err: any) {
    // Log the REAL error — a generic "Download failed" message in the UI
    // hides whether this is a CORS block, a 403/404, or a network drop.
    // Open devtools console after clicking Download to see this.
    console.error("[downloadOriginalFile] failed for", url, "\nReason:", err?.message || err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};